import React from 'react'
import {IParamOption} from '../../modules/core'

interface ISelectProps {
  name: string
  source: IParamOption[] | undefined
  field: {name: string; value: any; onChange: () => void}
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  }
  className: string
  defaultOption: boolean
  disabled?: boolean
  onSelectedChange?: (val: any) => void
}

export const FormSelect: React.FC<ISelectProps> = (props) => {
  const sourceStr = props.source?.map((item: IParamOption) => ({
    id: String(item.id),
    label: item.label,
  }))

  return (
    <>
      {sourceStr && (
        <select
          className={props.className}
          name={props.field.name}
          value={props.field.value}
          disabled={props.disabled}
          onChange={(val) => {    
           
            val && props.form.setFieldValue(props.field.name, val.target.value.toString())
            if (sourceStr && val) {
              var finById = sourceStr.find((x) => x.id === val.target.value)
              props.onSelectedChange?.(finById)
            }

            
          }}
        >
          {props.defaultOption && <option value={''}></option>}
          {sourceStr.map((item, index) => {
            return (
              <option key={index} value={item.id}>
                {item.label}
              </option>
            )
          })}
        </select>
      )}
    </>
  )
}
